/* eslint-disable no-param-reassign */
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import WeblabId from 'src/weblab/weblabId';
import WeblabTreatment from 'src/weblab/weblabTreatment';
import type { AppState } from '../store';

export interface WeblabItem {
  id: WeblabId,
  treatment: WeblabTreatment
}

export interface WeblabState {
  weblabList: WeblabItem[]
}

export const initialState: WeblabState = {
  weblabList: [],
};

const weblabSlice = createSlice({
  name: 'weblab',
  initialState,
  reducers: {
    setWeblabList: (
      state: WeblabState,
      action: PayloadAction<WeblabItem[] | undefined>,
    ) => {
      state.weblabList = action.payload || [];
    },

  },
});
export const selectWeblabList = (state: AppState) => state.weblab.weblabList;
export const selectIsWeblabIdInT1 = createSelector(
  [
    selectWeblabList,
    (state: AppState, weblabId: WeblabId) => weblabId,
  ],
  (weblabList, weblabId) => weblabList.find(
    (weblab) => weblab.id === weblabId,
  )?.treatment === WeblabTreatment.T1,
);

export const weblabActions = weblabSlice.actions;

export default weblabSlice.reducer;
